module.exports = __webpack_public_path__ + "img/login_tab01_04.59e10c2f.png";